import { Remark } from "react-remark";
import rehypeAutoLinkHeadings from "rehype-autolink-headings";
import rehypeSlug from "rehype-slug";
import remarkGemoji from "remark-gemoji";

export interface Props {
  articleBody: string;
  proseLead?: string;
  proseHeaders?: string;
  proseList?: string;
  proseParagraph?: string;
  proseImg?: string;
  proseWidth?: string;
  prosePadding?: string;
  proseUl?: string;
  arabic?: boolean;
}

const MarkDown = ({
  articleBody,
  proseLead,
  proseHeaders,
  proseList,
  proseParagraph,
  proseImg,
  proseWidth,
  prosePadding,
  proseUl,
  arabic = false,
}: Props) => {
  return (
    <article
      className={`prose-headings:mb-7 prose-headings:mt-12 prose-headings:relative prose-a:!m-0 prose-a:relative prose-p:!m-0 prose-p:relative prose-li:!m-0 flex flex-col justify-start items-start md:prose-xl prose-sm lg:prose-lg 3xl:prose-xl font-Light prose-h3:md:text-2xl prose-h3:lg:text-3xl prose-strong:font-Medium prose-a:text-cultiv-blue ${
        proseImg ? proseImg : "prose-img:float-right prose-img:w-1/3"
      } prose-img:aspect-auto prose-img:object-fit prose-a:underline prose-a:decoration-2 prose-a:decoration-white hover:prose-a:decoration-cultiv-blue prose-a:transition-all prose-a:duration-500 prose-a:ease-in-out prose-a:underline-offset-4 will-change-transform  ${
        proseLead ? proseLead : "prose-lead:leading-6"
      } ${proseHeaders} ${proseList} ${proseParagraph} ${proseWidth} ${prosePadding} ${proseUl} `}
      dir={arabic ? "rtl" : "ltr"}
      lang={arabic ? "ar" : "en"}
    >
      <Remark
        remarkPlugins={[remarkGemoji as any]}
        remarkToRehypeOptions={{ allowDangerousHtml: true }}
        rehypePlugins={[rehypeSlug as any, rehypeAutoLinkHeadings]}
      >
        {articleBody}
      </Remark>
    </article>
  );
};

export default MarkDown;
